import * as t from 'io-ts';
import { user } from '@/services/api';

export const assignee = user;

export const assigneesCodec = t.type({
  data: t.array(t.type({
    id: t.number,
    name: t.string,
  })),
});
